import { Box, IconButton, Tooltip, Typography, Zoom } from '@mui/material';
import { Client } from 'interfaces/client';
import EnergySavingsLeafOutlinedIcon from '@mui/icons-material/EnergySavingsLeafOutlined';
import { useTranslation } from 'react-i18next';
import AutogiroModal from 'components/Invoice/AutogiroModal';

export function AutogiroStatus({ client, size = 'medium' }: { client: Client; size?: 'medium' | 'large' }) {
  const { t } = useTranslation();
  if (client.isAutogiro) {
    const statusKey = ['inactive', 'denied', 'cancelled', undefined].includes(client.autogiroStatus)
      ? 'activateAutogiroModal.registerAutogiro'
      : `client.autogiro_${client.autogiroStatus}`;

    const isClickable = ['inactive', 'denied', 'cancelled', undefined].includes(client.autogiroStatus);

    return (
      <AutogiroModal client={client}>
        {({ onClick }) => (
          <Box
            display="flex"
            alignItems="center"
            onClick={isClickable ? onClick : undefined}
            sx={{ cursor: isClickable ? 'pointer' : 'default' }}
          >
            <IconButton disabled={!isClickable} sx={{ p: 0.5 }}>
              <EnergySavingsLeafOutlinedIcon
                fontSize={size}
                color={
                  client.autogiroStatus === 'active'
                    ? 'success'
                    : client.autogiroStatus === 'pending'
                    ? 'info'
                    : isClickable
                    ? 'primary'
                    : 'warning'
                }
              />
            </IconButton>
            <Typography
              variant="caption"
              color={
                client.autogiroStatus === 'active'
                  ? 'success.main'
                  : client.autogiroStatus === 'pending'
                  ? 'info.main'
                  : 'primary.main'
              }
              sx={{
                ml: 0.5,
                fontWeight: client.autogiroStatus === 'active' ? 600 : 400,
                '&:hover': {
                  opacity: isClickable ? 0.8 : 1,
                },
              }}
            >
              {t(statusKey)}
            </Typography>
          </Box>
        )}
      </AutogiroModal>
    );
  }

  return null;
}
